import { render, staticRenderFns } from "./OrderServiceAutocomplete.vue?vue&type=template&id=19881338"
import script from "./OrderServiceAutocomplete.vue?vue&type=script&lang=js"
export * from "./OrderServiceAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports